// application constants
export const MOBILE_WIDTH = 500;
export const PATHS = {
  root: '/',
  privacy: '/privacy-policy',
  terms: '/terms-of-use',
};

// vendor constants
export const HOTJAR_ID = 770741;
export const HOTJAR_VERSION = 6;

export const FIREBASE_DEV = {
  apiKey: "AIzaSyDW1sNaZTrrtE5uvC1swpFcMhBbI0ohVEA",
  authDomain: "argo-dev.firebaseapp.com",
  databaseURL: "https://argo-dev.firebaseio.com",
  projectId: "argo-dev",
  storageBucket: "argo-dev.appspot.com",
  messagingSenderId: "824354992842"
};

export const FIREBASE_PROD = {
  apiKey: "AIzaSyCR7SIyDbrwOpWD3vV8D8rC2nYIhIZL-iw",
  authDomain: "argoumich.firebaseapp.com",
  databaseURL: "https://argoumich.firebaseio.com",
  projectId: "project-3189383347973321089",
  storageBucket: "project-3189383347973321089.appspot.com",
  messagingSenderId: "375923952244"
};



// WEBPACK FOOTER //
// ./src/lib/constants.js